import { render, staticRenderFns } from "./CustomerFormModal.vue?vue&type=template&id=6df5902b&scoped=true&"
import script from "./CustomerFormModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerFormModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5902b",
  null
  
)

export default component.exports